import { render } from "./ThePagination.vue?vue&type=template&id=e7850bae"
import script from "./ThePagination.vue?vue&type=script&scoped=true&lang=js"
export * from "./ThePagination.vue?vue&type=script&scoped=true&lang=js"

import "./ThePagination.vue?vue&type=style&index=0&id=e7850bae&lang=css"

import exportComponent from "C:\\project\\webtrackandtrace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__